import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EnviaInteracoesProcesso } from './types';

export const INITIAL_STATE: EnviaInteracoesProcesso = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EnviaInteracoesProcesso {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIA_INTERACOES_PROCESSO_REQUEST: {
				break;
			}
			case Types.ENVIA_INTERACOES_PROCESSO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ENVIA_INTERACOES_PROCESSO_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.ENVIA_INTERACOES_PROCESSO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
